function CheckoutTracker(analytics) {

    this.analytics = analytics;

    this.inputLocations = {
        'header': 'Header',
        'product': 'Product',
        'cart': 'Cart'
    };

    this.$paymentOptions = $('[name="optionsPayment"]');
    this.$addressOptions = $('[name="optionsAddress"]');
    this.$review = $('#review');
    // this.$payment = $('#select-payment');
    this.$backToPayment = $('#back-to-payment');
    this.$shippingContinue = $('.checkout-summary__continue');
    this.$shippingBack = $('.checkout-shipping__back');
}

CheckoutTracker.prototype = {
    init() {
        this.initPaymentPageTracking();
        // this.initPageTracking();
    },


    initPaymentPageTracking() {
        if (!this.$paymentOptions.length) {
            return;
        }

        this.$review.on('click', $.proxy(this.trackSelectedPayment, this));
    },

    /**
     * @return {CheckoutTracker}
     */
    initPageTracking() {
        this.$shippingBack.on('click', this.analytics.pageView.bind(this.analytics, '/checkout/shipping/'));
        this.$shippingContinue.on('click', this.sendShippingPageView.bind(this));
        this.$payment.on('click', this.analytics.pageView.bind(this.analytics, '/checkout/order/payment/'));
        this.$review.on('click', this.analytics.pageView.bind(this.analytics, '/checkout/order/review/'));
        this.$backToPayment.on('click', this.analytics.pageView.bind(this.analytics, '/checkout/order/'));
        return this;
    },

    /**
     * @returns {CheckoutTracker}
     */
    // sendShippingPageView() {
    //     this.analytics.pageView(this.getShippingPage());

    //     return this;
    // },

    /**
     * @return {CheckoutTracker}
     */
    trackSelectedPayment() {
        this.analytics.track(
            {
                eventName: 'Payment',
                eventBody: {
                    event_category: 'Selected',
                    event_label: this.$paymentOptions.filter(':checked').data('type'),
                    value: 1
                }
            });
        return this;
    },

    // /**
    //  * @returns String}
    //  */
    // getShippingPage() {

    //     var shippingType = this.$addressOptions.filter(':checked').val();

    //     if (shippingType === 'different') {
    //         return '/checkout/shipping/address/';
    //     }

    //     return '/checkout/shipping/fitting-station/';
    // }
};

export default CheckoutTracker;